var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgTimeAlt = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12 1.5C6.214 1.5 1.5 6.214 1.5 12S6.214 22.5 12 22.5 22.5 17.786 22.5 12 17.786 1.5 12 1.5Zm0 1.615A8.873 8.873 0 0 1 20.885 12 8.873 8.873 0 0 1 12 20.885 8.873 8.873 0 0 1 3.115 12 8.873 8.873 0 0 1 12 3.115Zm-.808 1.616v8.077h4.846v-1.616h-3.23V4.731h-1.616Z",
  fill: "#1A1A1A"
})));
export default SvgTimeAlt;